import { GameLauncher } from 'Roblox';
import angular from 'angular';
import placesListModule from '../placesListModule';
import { getExpirationMS, storeSortData } from '../../../core/services/gameSortSerivce';

function gamesService($q, resources, httpService) {
  'ngInject';

  function buildBatchPromises(arrayNeedsBatch, cutOff, urlConfig, key) {
    const promises = [];
    let startIndex = 0;
    let subArray = arrayNeedsBatch.slice(startIndex, cutOff);
    while (subArray.length > 0) {
      const params = {};
      params[key] = subArray;
      promises.push(httpService.httpGet(urlConfig, params));
      startIndex++;
      subArray = arrayNeedsBatch.slice(startIndex * cutOff, startIndex * cutOff + cutOff);
    }

    return $q.all(promises);
  }

  let timeoutGameSort = null;

  return {
    joinGame(placeId, gameInstanceId) {
      GameLauncher.joinGameInstance(placeId, gameInstanceId, true, true);
    },

    getHomeGameSorts(gameSortsContext) {
      const { apiParams, apiSets } = resources;
      const currentGameSortContext = gameSortsContext || apiParams.gameSortsContext;
      const params = {
        gameSortsContext: currentGameSortContext
      };
      if (timeoutGameSort) {
        clearTimeout(timeoutGameSort);
      }
      return httpService.httpGet(apiSets.getHomeGameSorts, params).then(data => {
        if (data?.sorts) {
          storeSortData(data, currentGameSortContext);
          const expirationMS = getExpirationMS(data.sorts);
          timeoutGameSort = setTimeout(() => {
            this.getHomeGameSorts();
          }, expirationMS);
        }
        return data;
      });
    },

    getPlacesDetails(placeIds) {
      return buildBatchPromises(
        placeIds,
        resources.apiParams.placeDetailsMultiGetLimit,
        resources.apiSets.multiGetPlaceDetails,
        'placeIds'
      ).then(function(data) {
        if (data && data.length > 0) {
          let placesDetails = [];
          angular.forEach(data, function(item) {
            placesDetails = placesDetails.concat(item);
          });
          return placesDetails;
        }
        return null;
      });
    },

    getGamesList(sortToken, gameSetTargetId, maxRows, sortPosition, pageContext) {
      const params = {
        sortToken,
        gameSetTargetId,
        maxRows,
        sortPosition
      };
      if (pageContext && pageContext.pageId) {
        params['pageContext.pageId'] = pageContext.pageId;
      }
      return httpService.httpGet(resources.apiSets.getGamesList, params);
    },

    getUnifiedGamesSort() {
      return httpService.httpGet(resources.apiSets.getUnifiedGamesSort, null);
    }
  };
}

placesListModule.factory('gamesService', gamesService);

export default gamesService;
